export const homeTranslations =  {
    // Navigation bar
    nav: {
      services: "الخدمات",
      community: "المجتمع",
      events: "الفعاليات",
      contact: "اتصل بنا",
      blog:"المدونة",
      signin: "تسجيل الدخول",
      getStarted: "ابدأ الآن"
    },
    // Hero Section
    hero: {
      title: "ارتقِ بمستوى اختباراتك",
      subtitle: "في كواليتي نكسس، نقدم حلول اختبار البرمجيات عالية التأثير مع رعاية مجتمع عالمي مزدهر من مهندسي ضمان الجودة.",
      exploreServices: "استكشف خدماتنا",
      joinCommunity: "انضم إلى المجتمع"
    },
    // Services Section
    services_section: {
      title: "خدمات اختبار البرمجيات لدينا",
      description: "حلول ضمان جودة شاملة مصممة خصيصًا لتلبية احتياجات مشروعك. يقدم فريقنا الخبير الجودة في كل خطوة من دورة تطوير البرمجيات.",
      learnMore: "اعرف المزيد",
      viewAll: "عرض جميع الخدمات",
      cards: {
        functionalTesting: {
          title: "الاختبار الوظيفي",
          description: "تأكد من أن برنامجك يعمل كما هو متوقع مع خدمات الاختبار الوظيفي الشاملة."
        },
        testAutomation: {
          title: "أتمتة الاختبارات",
          description: "عجل عملية التسليم باستراتيجيات وتنفيذ أتمتة الاختبارات الذكية."
        },
        performanceTesting: {
          title: "اختبار الأداء والحمل",
          description: "تحقق من أداء تطبيقك تحت ظروف تحميل مختلفة."
        },
        securityTesting: {
          title: "اختبار الأمان والثغرات",
          description: "حدد مخاطر الأمان وخففها قبل أن تؤثر على عملك."
        },
        usabilityTesting: {
          title: "اختبار سهولة الاستخدام وتجربة المستخدم",
          description: "حسن تجربة المستخدم من خلال التقييم والاختبار الخبير لتجربة المستخدم."
        },
        apiTesting: {
          title: "اختبار واجهات البرمجة والتكامل",
          description: "تأكد من التكامل السلس بين المكونات وخدمات الطرف الثالث."
        },
        qaConsulting: {
          title: "استشارات عملية ضمان الجودة",
          description: "حسن عمليات ضمان الجودة لديك بالإرشاد الخبير وأفضل الممارسات."
        },
        testStrategy: {
          title: "تصميم استراتيجية الاختبار",
          description: "طور استراتيجيات اختبار شاملة مصممة خصيصًا لاحتياجات مشروعك."
        },
        accessibilityTesting: {
          title: "اختبار إمكانية الوصول",
          description: "اجعل برنامجك متاحًا لجميع المستخدمين من خلال اختبارات متخصصة."
        }
      }
    },
    // Community Section
    community: {
      communityLabel: "منصة المجتمع",
      title: "منصة متكاملة صُممت لمختبري البرمجيات",
      description: "تجمع منصة مجتمع Quality Nexus الملفات المهنية والتواصل والإرشاد والتعلّم والفرص في مكان واحد، لتطوّر مسيرتك في ضمان الجودة مع أشخاص يفهمون مجالك.",
      features: {
        profile: {
          title: "ملفات مهنية للمختبرين",
          description: "أنشئ ملفًا غنيًا يعرض مهاراتك وخبراتك وشهاداتك وأعمالك في ضمان الجودة."
        },
        feed: {
          title: "منشورات ونقاشات اجتماعية",
          description: "شارك تحديثاتك واطرح أسئلتك وانضم إلى نقاشات مجتمع الاختبار."
        },
        connections: {
          title: "التواصل والمراسلة",
          description: "تابع المختبرين ووسّع شبكتك وتحدث مباشرة مع الزملاء والخبراء."
        },
        mentorship: {
          title: "الإرشاد ومجموعات الدراسة",
          description: "اعثر على مرشد أو كن مرشدًا، أو تعلّم مع الآخرين ضمن مجموعات متخصصة."
        }
      },
      visitCommunityButton: "استكشف المنصة",
      becomeMentorButton: "كن موجهاً",
      highlights: {
        label: "مباشر",
        title: "داخل المجتمع",
        ctaButton: "أنشئ ملفك كمختبر",
        studyGroups: { title: "مجموعات الدراسة", description: "مسارات الأتمتة وواجهات API والأداء", action: "أنشئ مجموعة أو انضم إليها", status: "متاح الآن" },
        discussions: { title: "النقاشات", description: "اسأل وأجب وشارك خبرات الاختبار", action: "أسئلة وأجوبة مترابطة", status: "نشاط يومي" }
      },
      modules: {
        title: "متاح أيضًا على المنصة",
        roadmaps: "مسارات التعلّم",
        tools: "دليل الأدوات",
        events: "الفعاليات واللقاءات",
        jobs: "وظائف ضمان الجودة",
        link: "اطّلع على كل المزايا"
      },
    },
    // قسم الفعاليات
    events: {
      title: "الفعاليات والإعلانات",
      description: "انضم إلى فعالياتنا القادمة والندوات والاجتماعات المجتمعية لتعزيز معرفتك في الاختبار والتواصل مع محترفين آخرين."
    },
    // قسم الاختبار الجماعي
    crowdSourced: {
      label: "قريبًا",
      title: "الاختبار الجماعي",
      description: "انضم إلى نهجنا المبتكر في اختبار البرمجيات الذي يستفيد من القوة الجماعية لمجتمعنا العالمي.",
      testers: {
        title: "لمهندسي الاختبار",
        description: "طبّق مهاراتك في اختبار البرمجيات على مشاريع حقيقية. اربح مكافآت، وطور ملفك، ووسع شبكتك المهنية.",
        button: "شكّل مستقبل تجربتك في الاختبار"
      },
      businessOwners: {
        title: "لأصحاب الأعمال",
        description: "احصل على تعليقات واقعية من مختبرين متنوعين. حسّن جودة منتجك من خلال رؤى من مجتمعنا العالمي.",
        button: "شكّل حل الاختبار الذي تحتاجه"
      },
      launchStatement: {
        part1: " الإطلاق مقرر في",
        launchDate: " نوفمبر 2026",
        part2: " — انضم مبكرًا للحصول على مزايا حصرية"
      }
    },
    // Testimonials section
    reviews: {
      title: "آراء المستخدمين",
      description: "اكتشف كيف أثرت Quality Nexus في حياة عملائنا وأفراد المجتمع.",
      companiesTitle: "شركات مبتكرة تثق بنا"
    },
    // CTA Section
    ctaSection: {
      title: "مستعد للانتقال باختباراتك إلى المستوى التالي؟",
      description: "انضم إلى Quality Nexus اليوم لتعزيز قدراتك في الاختبارات وتصبح جزءًا من مجتمعنا النابض بالحياة لعشاق الجودة.",
      servicesButton: "اكتشف الخدمات",
      communityButton: "انضم إلى المجتمع"
    }, 
    // Footer
    footer: {
      about: "طور أداء اختباراتك مع Quality Nexus، حيث تجد خدمات اختبارات خبيرة مجتمعًا عالميًا نابضًا بالحياة لمهندسي الاختبارات والجودة.",
      quickLinks: {
        title: "روابط سريعة",
        services: "الخدمات",
        community: "المجتمع",
        events: "الفعاليات",
          blog:"المدونة",
        contact: "اتصل بنا",
        about: "من نحن"
      },
      services: {
        title: "الخدمات",
        mobileApps: "اختبار تطبيقات الهاتف المحمول",
        api: "اختبار واجهات برمجة التطبيقات",
        performance: "اختبارات الأداء",
        security: "اختبارات الأمان",
        all: "جميع الخدمات ←"
      },
      newsletter: {
        title: "النشرة البريدية",
        description: "اشترك في نشرتنا البريدية للحصول على آخر التحديثات والفعاليات وأخبار المجتمع.",
        emailPlaceholder: "عنوان بريدك الإلكتروني",
        subscribe: "اشتراك"
      },
      copyrights: "Quality Nexus. جميع الحقوق محفوظة.",
      privacy: "سياسة الخصوصية",
      terms: "شروط الخدمة"
    }
  };
